module.exports = __webpack_public_path__ + "static/media/step_3.bda1f8ad.png";